var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTodayGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.5 23c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5-2.5 1.1193-2.5 2.5 1.1193 2.5 2.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.125 7c0-.62132-.5037-1.125-1.125-1.125s-1.125.50368-1.125 1.125v1.875h-3.125c-2.1401 0-3.875 1.7349-3.875 3.875v16.5c0 2.1401 1.7349 3.875 3.875 3.875h20.5c2.1401 0 3.875-1.7349 3.875-3.875v-16.5c0-2.1401-1.7349-3.875-3.875-3.875h-3.125v-1.875c0-.62132-.5037-1.125-1.125-1.125s-1.125.50368-1.125 1.125v1.875h-9.75zm-7 10v12c0 1.0355.83947 1.875 1.875 1.875h20c1.0355 0 1.875-.8395 1.875-1.875v-12c0-1.0355-.8395-1.875-1.875-1.875h-20c-1.03553 0-1.875.8395-1.875 1.875z",
    fillRule: "evenodd"
  }))));
}

export default SvgTodayGlyph;